<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <card-header title="심사하기"></card-header>
          <v-card-text>
            <!-- 투고 정보 -->

            <v-row>
              <v-col cols="12" lg="6">
                <v-row>
                  <v-col cols="12">
                    <div class="d-flex justify-space-between">
                      <h4>{{ titles.paper }}</h4>
                      <!-- <custom-button
                    color="primary"
                    :label="buttons.pdf"
                    @click="generatePdfPreview"
                    rounded
                  ></custom-button> -->
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div
                      class="text-container"
                      v-if="review.paper?.journal?.title"
                    >
                      <label class="first-section-label">
                        {{ $t("label.journal") }}
                      </label>
                      <div>
                        {{ review.paper?.journal?.title }}
                      </div>
                    </div>
                    <div
                      class="text-container"
                      v-for="field in paperfields"
                      :key="field.idx"
                    >
                      <label class="first-section-label">{{
                        field.label
                      }}</label>
                      <div v-if="field.type === 'html'">
                        <div v-html="review.paper[field.key]"></div>
                      </div>
                      <div
                        v-else-if="
                          field.type === 'file' && review.paper[field.key]
                        "
                      >
                        <button
                          @click="handleFileClick(review.paper[field.key])"
                          class="file-download"
                        >
                          {{ getFileName(review.paper[field.key]) }}
                        </button>
                      </div>
                      <div v-else>
                        {{ review.paper[field.key] }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" lg="6">
                <v-card
                  :height="800"
                  outlined
                  class="rounded-lg overflow-y-auto"
                  color="grey lighten-3"
                >
                  <v-card-text>
                    <div class="d-flex justify-center align-center">
                      <div ref="pdfContent">
                        <component
                          v-if="review.paper && review.paper.idx"
                          :is="selectedPdfTemplate"
                          :item="review?.paper"
                          :journal="review?.paper?.journal"
                          :startPageNumber="startPageNumber"
                        />
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <h4>{{ titles.review }}</h4>
              </v-col>
              <v-col cols="12">
                <simple-table-content
                  :columns="tableColumns"
                  :data="review.criteria_scores"
                  :max-score="10"
                  readonly
                ></simple-table-content>
                <hr />
                <div class="d-flex justify-end text-h6 font-weight-bold ma-5">
                  {{ totalScoreLabel }} {{ totalScore }}
                </div>
              </v-col>
            </v-row>

            <!-- 게재 여부 -->
            <v-row>
              <v-col cols="12">
                <h4>{{ titles.result }}</h4>
                <hr class="mt-4" />
              </v-col>
              <v-col cols="12">
                <div class="radio-container">
                  <div v-for="(option, index) in options" :key="index">
                    <input
                      type="radio"
                      name="result"
                      :value="option.idx"
                      v-model="review.result_type.idx"
                      disabled
                    />
                    {{ option.label }}
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- 심사 내용 -->
            <v-row>
              <v-col cols="12">
                <h4>{{ titles.comment }}</h4>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="review.comment"
                  outlined
                  readonly
                ></v-textarea>
              </v-col>
            </v-row>

            <!-- 버튼 영역 -->
            <div class="d-flex justify-end">
              <custom-button
                color="black"
                :label="buttons.close"
                @click="handleClose"
                rounded
                gradient
              ></custom-button>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <!-- PDF 콘텐츠 (숨겨진 상태로 렌더링) -->
        <!-- <div ref="pdfContent" style="display: none">
          <component
            v-if="review.paper && review.paper.idx"
            :is="selectedPdfTemplate"
            :item="review?.paper"
            :journal="review?.paper?.journal"
            :startPageNumber="startPageNumber"
          />
        </div> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ArticlePaperPage from "@/components/Templates/article/ArticlePaperPage.vue";
import AbstractPaperPage from "@/components/Templates/abstract/AbstractPaperPage.vue";
import ProceedingsPaperPage from "@/components/Templates/proceedings/ProceedingsPaperPage.vue";
import ArticlePreviewTemplate from "@/components/Templates/ArticlePreviewTemplate.vue";

import CardHeader from "@/components/cards/CardHeader.vue";
import SimpleTableContent from "@/components/Tables/SimpleTableContent.vue";
import CustomButton from "@/components/common/buttons/CustomButton.vue";

import { paperInfofields, resultOptions } from "@/views/ReviewView/fields";
import { getScoreTableColumnsColumns } from "@/views/ReviewView/columns";
import { editReviewLabel } from "@/views/ReviewView/label";
import { generateFinalPdf } from "@/utils/pdfGenerator";

import { reviewApi, fileApi } from "@/api/api";

export default {
  name: "edit-review",
  components: {
    CardHeader,
    SimpleTableContent,
    CustomButton,
    ArticlePaperPage,
    AbstractPaperPage,
    ProceedingsPaperPage,
    ArticlePreviewTemplate,
  },
  props: {
    idx: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      // label
      titles: editReviewLabel.titles,
      buttons: editReviewLabel.buttons,
      totalScoreLabel: editReviewLabel.totalScore,

      // fields & columns
      paperfields: paperInfofields,
      tableColumns: getScoreTableColumnsColumns({}),
      options: resultOptions,
      showPreviewModal: false,
      // init data
      totalScore: 0,
      review: {
        idx: this.idx,
        comment: null,
        level: null,
        paper: {
          idx: null,
          title: null,
          title_eng: null,
          subtitle: null,
          subtitle_eng: null,
          abstract: null,
          abstract_eng: null,
          content: null,
          content_eng: null,
          keyword: null,
          keyword_eng: null,
          review_type: null,
          submitted_at: null,
          journal: {},
        },
        result_type: {
          idx: null,
          name: null,
        },
        criteria_scores: [],
      },
    };
  },
  methods: {
    goReviewStatus() {
      this.$router.push({
        name: "review-status",
      });
    },
    generatePdfPreview() {
      const element = this.$refs.pdfContent;

      if (!element) {
        // eslint-disable-next-line no-console
        console.error("PDF 콘텐츠 요소를 찾을 수 없습니다.");
        return;
      }

      generateFinalPdf({ element: element });
    },
    /**
     * *****************************************************************************************
     * 버튼 액션
     * *****************************************************************************************
     */

    /**
     * 닫기 버튼 액션
     */
    async handleClose() {
      this.goReviewStatus();
    },
    /**
     * *****************************************************************************************
     * API 요청
     * *****************************************************************************************
     */
    /**
     * 심사 상세 데이터 api 요청
     */
    fetchReviewDetail(reviewIdx) {
      reviewApi.showReview({ idx: reviewIdx }).then((response) => {
        if (response && response.status == 200) {
          this.review = response.data.response;
          this.calculateTotalScore();
        } else {
          alert(editReviewLabel.apiRequestFailMessage);
        }
      });
    },
    calculateTotalScore() {
      const totalScore = this.review.criteria_scores.reduce(
        (total, criteria) => {
          return (total + Number(criteria.score)) | 0;
        },
        0
      );

      this.totalScore = totalScore;
    },
    getFileName(filePath) {
      return filePath.split("/").pop();
    },
    async handleFileClick(filePath) {
      try {
        const fileName = filePath.split("/").pop();
        const params = {
          file_name: filePath,
        };

        const response = await fileApi.fileDownload(params);

        if (response && response.status === 200) {
          const mimeType = response.headers["content-type"];
          const blob = new Blob([response.data], { type: mimeType });
          const fileURL = URL.createObjectURL(blob);

          //   // 자동 열기
          //   if (mimeType === "application/pdf" || mimeType.startsWith("image/")) {
          //     const link = document.createElement("a");
          //     link.href = fileURL;
          //     link.setAttribute("download", fileName); // 다운로드 파일 이름 설정
          //     link.setAttribute("target", "_blank"); // 새 창에서 열기
          //     document.body.appendChild(link);
          //     link.click();
          //     link.parentNode.removeChild(link);
          //   } else {
          // 다운로드로 처리
          const link = document.createElement("a");
          link.href = fileURL;
          link.setAttribute("download", fileName); // 다운로드 파일 이름 설정
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          // }
        }
      } catch (error) {
        alert("파일 다운로드에 실패했습니다. 잠시후 다시 시도해주세요.");
        // eslint-disable-next-line no-console
        console.error("File download failed:", error);
      }
    },
  },
  computed: {
    selectedPdfTemplate() {
      if (this.review.paper.journal?.journal_type?.code === "abst") {
        return "abstract-paper-page";
      } else if (this.review.paper.journal?.journal_type?.code === "procs") {
        return "proceedings-paper-page";
      }
      // return "article-paper-page";
      return "article-preview-template";
    },
    startPageNumber() {
      if (this.review.paper?.journal?.journal_type?.code === "jnl") {
        return 2;
      }
      return 1;
    },
  },
  mounted() {
    this.fetchReviewDetail(this.idx);
  },
};
</script>

<style lang="scss" scoped>
$font-color: #424242;

h4 {
  font-weight: bold;
  color: $font-color;
  margin-bottom: -2px;
}

hr {
  border: 1px solid rgba(233, 233, 233, 0.5);
}

.first-section-label {
  font-weight: 600;
  color: $font-color;
  min-width: 120px;
}

.text-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.radio-container {
  display: flex;
  justify-content: space-between;
}

.file-download {
  background: none;
  border: none;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
  margin: 0;
  outline: none;
}

.file-download:hover {
  color: #0056b3;
  text-decoration: none;
}

.file-download:focus {
  outline: none;
}
</style>
